import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";
import en from "./locales/en.json";
import vi from "./locales/vi.json";

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
  vi: {
    translation: vi,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language?.split("-")[0] || "en";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng?.split("-")[0] || "en";
  });
}

export default i18n;
